import Vue from 'vue';
import axios from 'axios';
import '../../../filters';
import moment from 'moment';
import * as files from '../../../fileUtils';
import { QrcodeStream } from 'vue-qrcode-reader';
import { WebCam } from 'vue-web-cam';
import { find, head } from 'lodash';

export default {
  name: 'elementsType',
  components: {
    TreeSelect: require('../../../customcontrols/selectOfTree.vue').default
  },
  data: function () {
    return {
      modules: [],
      module: '',
      sourceElementTypes: [],
      elementTypes: [],
      elementTypeNode: '',
      elementType: '',
      objElementType: null,
      groupElementTypesBy: 'system'
    }
  },
  watch: {
    module: {
      handler: function (val) {
        this.elementTypeNode = null;
        this.elementType = '';
        this.mapElementTypesForTree();
        this.$root.$emit('element_reset_emit');
      }
    },
    groupElementTypesBy: {
      handler: function (val) {
        this.mapElementTypesForTree();
      },
      deep: true
    },
    elementTypeNode: {
      handler: function (val) {
        if (!val)
          return;
        if(val == '')
          this.elementType = '';
        else
          this.elementType = val.id;

        this.$root.$emit('element_reset_emit');
      },
      deep: true
    }
  },
  created() {
    this.getModules();
    this.getElementTypes();
  },
  methods: {
    getModules() {
      axios.get('/Element/GetModules')
        .then(response => {
          if (response.status == 200) {
            this.modules = [];

            for (var i = 0; i < response.data.items.length; i++) {
              this.modules.push({
                id: response.data.items[i]['value'],
                label: response.data.items[i]['text'],
                group: response.data.items[i]['group'],
                selected: response.data.items[i]['selected'],
              });
            }

            if (this.modules.filter(a => a.selected).length > 0) {
              this.module = this.modules.filter(a => a.selected)[0].id;
            }
            else {
              this.module = '';
            }
          }
        })
        .catch(err => {
          this.$alertMsg(err);
        });
    },
    getElementTypes() {
      axios.get('/Element/GetElementTypes')
        .then(response => {
          if (response.status == 200) {
            this.sourceElementTypes = response.data.items;
            this.mapElementTypesForTree();
          }
        })
        .catch(err => {
          this.$alertMsg(err);
        });
    },
    mapElementTypesForTree() {
      this.elementTypes = [];
      let mainList = [];
      let childrenItems = [];

      let list = this.sourceElementTypes['System'];

      Object.keys(list).map((field) => {
        childrenItems = [];
        for (var i = 0; i < list[field].length; i++) {
          if (this.module == '' || this.module == null) {
            childrenItems.push({
              id: list[field][i].typeId,
              label: list[field][i].name,
              gisLayerName: list[field][i].gisLayerName,
              moduleId: list[field][i].moduleId,
            });
          }
          else {
            if (list[field][i].moduleId == this.module) {
              childrenItems.push({
                id: list[field][i].typeId,
                label: list[field][i].name,
                gisLayerName: list[field][i].gisLayerName,
                moduleId: list[field][i].moduleId,
              });
            }
          }
        }

        if (childrenItems.length > 0) {
          mainList.push({
            id: 'system_' + field,
            label: field,
            children: childrenItems
          });
        }
      });

      this.elementTypes.push({
        id: this.$t('assets.system'),
        label: this.$t('assets.system'),
        children: mainList
      });

      mainList = [];

      list = this.groupElementTypesBy == 'system' ? this.sourceElementTypes['CustomBySystem'] : this.sourceElementTypes['CustomByCustom'];

      Object.keys(list).map((field) => {
        childrenItems = [];
        for (var i = 0; i < list[field].length; i++) {
          if (this.module == '' || this.module == null) {
            childrenItems.push({
              id: list[field][i].typeId,
              label: list[field][i].name,
              gisLayerName: list[field][i].gisLayerName,
              moduleId: list[field][i].moduleId,
            });
          }
          else {
            if (list[field][i].moduleId == this.module) {
              childrenItems.push({
                id: list[field][i].typeId,
                label: list[field][i].name,
                gisLayerName: list[field][i].gisLayerName,
                moduleId: list[field][i].moduleId,
              });
            }
          }
        }

        if (childrenItems.length > 0) {
          mainList.push({
            id: 'custom_' + field,
            label: field,
            children: childrenItems
          });
        }
      });

      if (mainList.length > 0) {
        this.elementTypes.push({
          id: this.$t('assets.custom'),
          label: this.$t('assets.custom'),
          children: mainList
        });
      }
    }
  },
}
